webpackJsonp([49608520835679],{

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookAuth = __webpack_require__(34);
	
	var _LoreHookAuth2 = _interopRequireDefault(_LoreHookAuth);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookAuth2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Example Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you\'re building an application that consumes an API that returns information about the current user from the endpoint ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/user'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In order to retrieve the current user, we need three things in place:'
	    ),
	    _react2.default.createElement(
	      'ul',
	      null,
	      _react2.default.createElement(
	        'li',
	        null,
	        'A model representing that endpoint,'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'An action we can invoke the fetch the user'
	      ),
	      _react2.default.createElement(
	        'li',
	        null,
	        'A reducer we can use to store the user'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unlike the build-in blueprints, this flow is special in that the action will ',
	      _react2.default.createElement(
	        'strong',
	        null,
	        'always'
	      ),
	      ' communicate with the same endpoint (',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/user'
	      ),
	      ') and the reducer will only store a ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'single'
	      ),
	      ' object, as opposed to a ',
	      _react2.default.createElement(
	        'em',
	        null,
	        'set'
	      ),
	      ' of objects like the built-in ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'find'
	      ),
	      ', ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'byId'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'byCid'
	      ),
	      ' reducers.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Without this hook, if you wanted to retrieve the current user, you would need to generate the following files yourself:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      src\n      |-actions\n        |-currentUser\n          |-get.js\n      |-models\n        |-currentUser.js\n      |-reducers\n        |-currentUser.js\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' model would describe the API endpoint, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser.get'
	      ),
	      ' action would retrieve the user, and the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' reducer would store the user.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This hook prevents you from needing to create the custom ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'action'
	      ),
	      ' and ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'reducer'
	      ),
	      '. Instead, you only need to create the model and specify what endpoint the action should fetch the current user from.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Here is an example ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'currentUser'
	      ),
	      ' model, that sets the endpoint to be ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '/user'
	      ),
	      ' (matching our API):'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      module.exports = {\n        endpoint: \'user\'\n      }\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Once this model exists (and assuming the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'modelName'
	      ),
	      ' field in the config matches the name of this model) you can fetch the current user through a ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore.connect'
	      ),
	      ' call like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      lore.connect(function(getState, props) {\n        return {\n          user: getState(\'currentUser\')\n        };\n      })\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-auth-usage-index-js-9d25a362187102617d1f.js